import { cva } from "cva";

export const headerMobileMenuStyles = cva({
  base: "fixed top-64 left-0 right-0 bottom-0 z-100 bg-ink-600 transition-opacity duration-250 ease-out-quad max-h-[calc(100dvh-64px)] pb-32 overflow-y-auto md:hidden",
  variants: {
    menuOpen: {
      true: "opacity-100 pointer-events-auto",
      false: "opacity-0 pointer-events-none",
    },
  },
});

export const headerMobileMenuContentStyles = cva({
  base: "flex flex-col gap-4 w-full bg-white rounded-b-md",
});
